import classNames from 'classnames';
import ArrowCircledIcon from '../../images/arrow-circled-icon.svg';
import CloseIconLarge from '../../images/close-icon-large.svg';

import './NavigationBar.scss';

const NavigationBar = ({
  title,
  onGoBack,
  onClose,
  className = '',
  backTrackerProps = {},
  closeTrackerProps = {},
}) => (
  <div className={classNames('NavigationBar', className)}>
    <button
      type="button"
      className="NavigationBar__back"
      onClick={onGoBack}
      disabled={!onGoBack}
      {...backTrackerProps}
    >
      {onGoBack && (
        <img src={ArrowCircledIcon} alt="back icon" />
      )}
    </button>
    <span className="NavigationBar__title">{title}</span>
    <button
      type="button"
      className="NavigationBar__close"
      onClick={onClose}
      disabled={!onClose}
      {...closeTrackerProps}
    >
      {onClose && (
        <img src={CloseIconLarge} alt="close icon" />
      )}
    </button>
  </div>
);

export default NavigationBar;
